import React from "react";
import "./homepage.css";
import logo from "../../images/logo.png";
import listImage from "../../images/landingpage/front.svg";
import leaderboardImage from "../../images/landingpage/leaderboard.svg";
import mockup from "../../images/landingpage/mockup.png";
import Footer from "./Footer";
import { Link, Navigate } from "react-router-dom";

export const Homepage = () => {
  if (document.cookie) return <Navigate to="/dashboard" />;
  return (
    <div id="home-hero-container">
      <nav id="home-nav-container">
        <img id="home-nav-logo" src={logo} alt="Logo" />
        <div id="home-nav-navigation">
          <Link to="/signup">
            <button id="nav-register-btn" className="home-register-btn">
              Register
            </button>
          </Link>
          <Link to="/signin">
            <button className="home-login-btn">Login</button>
          </Link>
        </div>
      </nav>
      <div id="home-main-content">
        <div id="main-content-text">
          <h1 className="main-heading">
            Manage & Organise your family with FamilyPlanner
          </h1>
          <p className="sub-heading">
            FamilyPlanner is a tool specially made to help you and your family
            organise daily tasks and communicate better.
          </p>
          <div id="home-cto-container">
            <p id="cto-paragraph">
              Ready to take your family organisation to the next level?
            </p>
            <Link to="/dashboard">
              <button id="cto-btn" className="home-register-btn">
                Register for Free!
              </button>
            </Link>
          </div>
        </div>
        <img id="landing-image" src={listImage} />
        {/* <i id="homepage-arrow"></i> */}
      </div>
      <div id="home-leaderboard-container">
        <h1 className="main-heading main-heading-centered">
          Compete with your family
          <br />
          on the leaderboard
        </h1>
        <p className="sub-heading sub-heading-centered">
          Get FP points by completing tasks
          <br />
          and climb the ladder!
        </p>
        <img id="home-leaderboard-image" src={leaderboardImage} />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 795.701 550.969"
          id="blob-blue"
          className="blob"
        >
          <path
            data-name="Path 35"
            d="M361.388-6.9C560.985-10.693,721.5,58.658,719.907,148S566.684,365.8,367.087,369.588-4.489,251.069-2.9,161.729,161.791-3.11,361.388-6.9Z"
            transform="matrix(0.966, -0.259, 0.259, 0.966, 4.633, 193.138)"
            fill="#c1e2ff"
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="blob-leaderboard-title"
          className="blob"
          viewBox="0 0 367.543 436.245"
        >
          <path
            data-name="Path 34"
            d="M137.99-6.9c77.2-3.791,139.279,65.56,138.664,154.9s-59.262,217.8-136.46,221.589S-3.519,251.069-2.9,161.729,60.792-3.11,137.99-6.9Z"
            transform="matrix(0.966, -0.259, 0.259, 0.966, 4.633, 78.414)"
            fill="#f2b4b4"
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="blob-yellow"
          className="blob"
          viewBox="0 0 367.543 436.245"
        >
          <path
            data-name="Path 33"
            d="M137.99-6.9c77.2-3.791,139.279,65.56,138.664,154.9s-59.262,217.8-136.46,221.589S-3.519,251.069-2.9,161.729,60.792-3.11,137.99-6.9Z"
            transform="matrix(0.966, -0.259, 0.259, 0.966, 4.633, 78.414)"
            fill="#fbecbf"
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="blob"
          id="blob-orange"
          viewBox="0 0 795.701 550.969"
        >
          <path
            data-name="Path 31"
            d="M361.388-6.9C560.985-10.693,721.5,58.658,719.907,148S566.684,365.8,367.087,369.588-4.489,251.069-2.9,161.729,161.791-3.11,361.388-6.9Z"
            transform="matrix(0.966, -0.259, 0.259, 0.966, 4.633, 193.138)"
            fill="#ffdbac"
          />
        </svg>
      </div>
      <div id="home-dashboard-container">
        <div>
          <h1 className="main-heading main-heading-centered">
            Your dashboard, however
            <br />
            you want it to look
          </h1>
          <p
            className="sub-heading sub-heading-centered"
            id="sub-heading-dashboard"
          >
            Rearrange and pin lists according
            <br />
            to what matters to you.
          </p>
          <div id="home-cta-dashboard">
            <p id="cto-paragraph" className="dashboard-cta-p">
              Sounds good?
            </p>
            <Link to="/dashboard">
              <button
                id="cto-btn"
                className="home-register-btn dashboard-cta-btn"
              >
                Register for Free!
              </button>
            </Link>
          </div>
        </div>
        <img id="home-mockup-image" src={mockup} />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 367.543 436.245"
          id="blob-mac"
          className="blob"
        >
          <path
            data-name="Path 37"
            d="M137.99-6.9c77.2-3.791,139.279,65.56,138.664,154.9s-59.262,217.8-136.46,221.589S-3.519,251.069-2.9,161.729,60.792-3.11,137.99-6.9Z"
            transform="matrix(0.966, -0.259, 0.259, 0.966, 4.633, 78.414)"
            fill="#f2b4b4"
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 809.823 610.74"
          id="blob-dashboard-text"
          className="blob"
        >
          <path
            data-name="Path 36"
            d="M361.388-6.9C560.985-10.693,721.5,58.658,719.907,148S566.684,365.8,367.087,369.588-4.489,251.069-2.9,161.729,161.791-3.11,361.388-6.9Z"
            transform="translate(135.194 7.624) rotate(21)"
            fill="#e8dfd3"
          />
        </svg>
      </div>
      <Footer />
    </div>
  );
};
